module.exports = __webpack_public_path__ + "img/small-2.752a2236.webp";